import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import PlannerPage from './PlannerPage';

const PlannerRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    console.log('PlannerRoutes path', path);
    return (
        <>
            <Switch>
                <Route exact path={`${path}`} component={PlannerPage} />
            </Switch>
        </>
    );
};

export default PlannerRoutes;
